if (!window.conceptNewsletterMemory) {
  const cookieName = 'concept:newsletter-subscribed';
  const storageKey = 'concept:newsletter-subscribed-until';
  const lifetime = 365 * 24 * 60 * 60;

  const isSubscribed = () => {
    try {
      if (document.cookie.split(';').some((cookie) => cookie.trim() === `${cookieName}=true`)) return true;
    } catch {}
    try {
      return Number(localStorage.getItem(storageKey)) > Date.now();
    } catch {
      return false;
    }
  };

  const rememberSignup = () => {
    try {
      document.cookie = `${cookieName}=true; max-age=${lifetime}; path=/; SameSite=Lax; Secure`;
    } catch {}
    try {
      localStorage.setItem(storageKey, String(Date.now() + lifetime * 1000));
    } catch {}
    document.documentElement.dataset.newsletterSubscribed = 'true';
  };

  window.conceptNewsletterMemory = Object.freeze({ isSubscribed });

  if (!window.Shopify?.designMode && document.querySelector('[data-newsletter-signup-success]')) {
    rememberSignup();
  }

  if (isSubscribed()) {
    document.documentElement.dataset.newsletterSubscribed = 'true';
  }
}

if (!customElements.get('newsletter-modal')) {
  customElements.define(
    'newsletter-modal',
    class NewsletterModal extends ModalElement {
      constructor() {
        super();
    
        // Prevent popup on Shopify robot challenge page
        if (window.location.pathname === '/challenge' || !theme.cookiesEnabled()) {
          return;
        }
    
        if (!theme.config.isTouch || Shopify.designMode) {
          this.init();
        }
        else {
          new theme.initWhenVisible(theme.utils.throttle(this.init.bind(this)));
        }
      }
    
      get shouldLock() {
        return true;
      }
    
      get testMode() {
        return this.getAttribute('data-test-mode') === 'true';
      }
    
      get delay() {
        return this.hasAttribute('data-delay') ? parseInt(this.getAttribute('data-delay')) : 5;
      }
    
      get expiry() {
        return this.hasAttribute('data-expiry') ? parseInt(this.getAttribute('data-expiry')) : 30;
      }
    
      get cookieName() {
        return 'concept:newsletter-visit-dismissed-v1';
      }
    
      get submited() {
        const response = this.querySelector('.alert');
        const form = this.querySelector('form.newsletter-form');
        return response !== null && (!window.location.hash || window.location.hash === `#${form?.id}`);
      }

      get behindLayer() {
        return !!this.closest('[inert]') || document.body.matches('.has-modal-open, .has-modal-opening');
      }
    
      init() {
        if (this.initialized) return;
        this.initialized = true;
        
        // Open modal if errors or success message exist
        if (this.submited) {
          this.load(1);
          return;
        }
    
        if (window.conceptNewsletterMemory.isSubscribed()) {
          this.suppress();
          return;
        }

        if (!this.testMode && this.getCookie(this.cookieName)) {
          this.maintainVisit();
          return;
        }

        if (this.testMode || !this.getCookie(this.cookieName)) {
          this.load(this.delay);
        }
      }
    
      maintainVisit() {
        if (this.visitTracking) return;
        this.visitTracking = true;
        let lastUpdated = 0;
        const refresh = () => {
          const now = Date.now();
          if (now - lastUpdated < 60000 || !this.getCookie(this.cookieName)) return;
          lastUpdated = now;
          this.setCookie(this.cookieName);
        };
        refresh();
        for (const eventName of ['pointerdown', 'keydown', 'scroll']) {
          document.addEventListener(eventName, refresh, { passive: true });
          this.registerCleanup(() => document.removeEventListener(eventName, refresh));
        }
      }

      load(delay) {
        if (Shopify.designMode) return;
    
        setTimeout(() => this.show(), delay * 1000);
      }

      suppress() {
        const section = this.closest('.shopify-section');
        if (section) {
          section.hidden = true;
          section.style.setProperty('display', 'none', 'important');
        }
      }

      show(activeElement = null, animate = true) {
        if (window.conceptNewsletterMemory.isSubscribed() && !this.submited) {
          this.suppress();
          return;
        }

        if (this.open) return;

        if (!Shopify.designMode && this.behindLayer) {
          this.showAfterLayer(activeElement, animate);
          return;
        }

        return super.show(activeElement, animate);
      }

      showAfterLayer(activeElement, animate) {
        if (this.layerObserver) return;

        this.layerObserver = new MutationObserver(() => {
          if (this.behindLayer) return;
          this.layerObserver.disconnect();
          this.layerObserver = null;
          this.show(activeElement, animate);
        });
        this.layerObserver.observe(document.body, { attributes: true, attributeFilter: ['inert', 'class'], subtree: true });
        this.registerCleanup(() => {
          this.layerObserver?.disconnect();
          this.layerObserver = null;
        });
      }
    
      afterShow() {
        super.afterShow();
        this.classList.add('show-image');
      }
    
      afterHide() {
        super.afterHide();
        this.classList.remove('show-image');
    
        // Remove a cookie in case it was set in test mode
        if (this.testMode) {
          this.removeCookie(this.cookieName);
          return;
        }
    
        this.setCookie(this.cookieName);
        this.maintainVisit();
        if (window.conceptNewsletterMemory.isSubscribed()) this.suppress();
      }
    
      getCookie(name) {
        try {
          const match = document.cookie.match(`(^|;)\\s*${name}\\s*=\\s*([^;]+)`);
          return match ? match[2] : null;
        } catch {
          return null;
        }
      }
    
      setCookie(name) {
        try {
          document.cookie = `${name}=true; max-age=${(30 * 60)}; path=/`;
        } catch {}
      }
    
      removeCookie(name) {
        try {
          document.cookie = `${name}=; max-age=0`;
        } catch {}
      }
    }
  );
}

